export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="sticky bottom-0 w-full border-t bg-background py-2.5 backdrop-blur  sm:py-3 md:py-4">
      <div className="container mx-auto flex flex-col items-center justify-between gap-1.5 text-[10px] text-gray-600 dark:text-gray-400 sm:flex-row sm:gap-2 sm:text-xs md:text-sm">
        <p className="whitespace-nowrap">
          © {currentYear} PriMES. All rights reserved.
        </p>
        <div className="flex items-center gap-1.5 sm:gap-2 md:gap-4">
          <span className="whitespace-nowrap">버전 1.0.0</span>
          <span className="text-gray-400">|</span>
          <span className="whitespace-nowrap">
            시스템 상태:{" "}
            <span className="font-medium text-green-600 dark:text-green-400">
              정상
            </span>
          </span>
        </div>
      </div>
    </footer>
  );
}
